import {
  FaBookmark,
  FaClipboardList,
  FaEnvelope,
  FaHandHoldingHeart,
  FaHeart,
  FaInfoCircle,
  FaMobileAlt,
  FaCompass,
  FaMosque,
  FaQuestionCircle,
  FaStickyNote,
  FaUserCircle,
  FaUsers,
} from 'react-icons/fa'
import { GiPrayerBeads } from 'react-icons/gi'
import { contentLibrary } from '../../consts'

// Filter content library items
export const tesbihatItems = contentLibrary.filter((item) =>
  item.keywords.toLowerCase().includes('tesbihat'),
)

export const otherContentItems = contentLibrary.filter(
  (item) => !item.keywords.toLowerCase().includes('tesbihat'),
)

// Navigation items with icons
export const navButtons = [
  { href: '/zikirmatik', name: 'Zikirmatik', icon: GiPrayerBeads },
  { href: '/dualar', name: 'Dualar', icon: FaMosque },
  {
    href: '/sizden-gelen-dualar',
    name: 'Sizden Gelen Dualar',
    icon: FaMosque,
  },
  { href: '/kaza-namazi-takibi', name: 'Kaza Namazı ve Oruç Takibi', icon: FaMosque },
  { href: '/not-defteri', name: 'Not Defteri', icon: FaStickyNote },
  { href: '/ortak-hatim', name: 'Ortak Hatim', icon: FaUsers },
  { href: '/kible-bulucu', name: 'Kıble Bulucu', icon: FaCompass },
  { href: '/koleksiyonum', name: 'Ayet Koleksiyonum', icon: FaBookmark },
  { href: '/sila-i-rahim-takibi', name: 'Sıla-i Rahim Takibi', icon: FaHeart },
  { href: '/hayirhahlarim', name: 'Hayırhahlarım', icon: FaHandHoldingHeart },
  { href: '/hesabim', name: 'Hesabım', icon: FaUserCircle },
]

export const otherButtons = [
  { href: '/uygulama', name: 'Mobil Uygulamamız', icon: FaMobileAlt },
  { href: '/rehber', name: 'Uygulama Rehberi', icon: FaQuestionCircle },
  { href: '/geri-bildirim/', name: 'Geri Bildirim', icon: FaEnvelope },
  {
    external: true,
    href: 'https://kurantime.com/hakkimizda',
    name: 'Hakkımızda',
    icon: FaInfoCircle,
  },
  { href: '/geri-bildirim', name: 'İletişim', icon: FaEnvelope },
  { href: 'versiyonlar', name: 'Güncelleme Geçmişi', icon: FaClipboardList },
]
